/*! responsive.js | Wealthuiux 2025 */

"use strict";

window.addEventListener('resize', () => {
    //console.log($(window).width())
})